var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProp = void 0;

var get_responsive_prop_1 = require("./get-responsive-prop");

exports.parseProp = function (_ref) {
  var config = _ref.config,
      theme = _ref.theme,
      name = _ref.name,
      value = _ref.value;
  var parsedProp;
  var result;

  if (config.ignoreProperties.includes(name)) {
    return;
  }

  if (Array.isArray(value)) {
    parsedProp = value;
  } else {
    parsedProp = [value];
  }

  Object.entries(config.stringMaps).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        stringMapName = _ref3[0],
        stringMapProperties = _ref3[1];

    if (stringMapProperties.includes(name)) {
      var newArray = [];
      parsedProp.forEach(function (item) {
        var newValue = item;

        if (typeof item === 'string') {
          var stringMap = theme[stringMapName];
          newValue = stringMap[item] || item;
        }

        newArray.push(newValue);
      });
      parsedProp = newArray;
    }
  });
  Object.entries(config.scales).forEach(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        scaleName = _ref5[0],
        scaleProperties = _ref5[1];

    if (scaleProperties.includes(name)) {
      var newArray = [];
      parsedProp.forEach(function (item) {
        var newValue = item;

        if (Number.isInteger(item)) {
          var scaleList = theme[scaleName];

          if (item < 0) {
            newValue = -scaleList[-item];
          } else {
            newValue = scaleList[item];
          }

          if (item === 0 && config.initialZeroScales.includes(scaleName)) {
            newValue = 'initial';
          }
        }

        newArray.push(newValue);
      });
      parsedProp = newArray;
    }
  });
  Object.entries(config.units).forEach(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        unit = _ref7[0],
        unitProperties = _ref7[1];

    if (unitProperties.includes(name)) {
      var newArray = [];
      parsedProp.forEach(function (item) {
        var newValue = item;

        if (typeof item === 'number') {
          if (unit === 'percent') {
            newValue *= 100;
            newValue += '%';
          } else {
            newValue += unit;
          }
        }

        newArray.push(newValue);
      });
      parsedProp = newArray;
    }
  });

  if (config.responsiveProperties.includes(name)) {
    result = get_responsive_prop_1.getResponsiveProp({
      theme: theme,
      propName: name,
      propValue: parsedProp
    });
  } else {
    if (parsedProp.length > 1 && process.env.NODE_ENV !== 'test') {
      console.log("WARNING: found unhandled responsive property '".concat(name, "'.\nUsing first value only. Consider adding this property to the\nresponsiveProperties config array"));
    }

    result = _defineProperty({}, name, parsedProp[0]);
  }

  return result;
};